/**
 * OrderService
 * Service for Order entity operations
 * Route: api/orders
 * Controller: OrdersController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * OrderService
 * Handles order CRUD operations and order-specific queries.
 * Backend now returns OrderModelView (enriched) instead of raw Order entities.
 * Maps to /api/orders endpoint
 */
export class OrderService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? OrderService.DEFAULT_SERVICE_PATH,
            basePath: OrderService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // Override getById to return OrderModelView
    async getById(id) {
        const response = await this.getByIdRaw(id);
        if (!response.data) {
            throw new Error(`Order with ID ${id} not found`);
        }
        return response.data;
    }
    getByIdRaw(id) {
        const url = this.buildUrl(String(id));
        return this.http.get(url);
    }
    // ==================== FILTER QUERIES ====================
    /**
     * Get filtered orders
     * GET /api/orders?statusId={statusId}&locationId={locationId}...
     */
    async getFiltered(filter) {
        const response = await this.getFilteredRaw(filter);
        return response.data ?? [];
    }
    /**
     * Get filtered orders (raw)
     */
    getFilteredRaw(filter) {
        const params = new URLSearchParams();
        if (filter.statusID !== undefined)
            params.append('statusId', String(filter.statusID));
        if (filter.locationID !== undefined)
            params.append('locationId', String(filter.locationID));
        if (filter.isProcessed !== undefined)
            params.append('isProcessed', String(filter.isProcessed));
        if (filter.referenceNo)
            params.append('referenceNo', filter.referenceNo);
        if (filter.dateFrom)
            params.append('dateFrom', filter.dateFrom instanceof Date ? filter.dateFrom.toISOString() : filter.dateFrom);
        if (filter.dateTo)
            params.append('dateTo', filter.dateTo instanceof Date ? filter.dateTo.toISOString() : filter.dateTo);
        const url = this.buildUrl(`?${params.toString()}`);
        return this.http.get(url);
    }
}
OrderService.DEFAULT_SERVICE_PATH = 'orders';
OrderService.BASE_PATH = 'api/orders';
//# sourceMappingURL=OrderService.js.map